import React, { useEffect, useState } from 'react';
import { Box, MenuItem, TextField } from '@mui/material';
import UIButton from 'components/ui/UIButton';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { adminActions } from 'features/feedback/store/admin.slice';
import { ALL_STATUSES, FeedbackStatus, STATUS_STYLE } from 'features/feedback/shared/feedback.types';

const TriageDetail: React.FC = () => {
  const dispatch = useAppDispatch();
  const { items, selectedId, saving } = useAppSelector((s) => s.admin);
  const item = items.find((it) => it.id === selectedId) || null;

  const [status, setStatus] = useState<FeedbackStatus>('NEW');
  const [note, setNote] = useState('');
  const [dup, setDup] = useState('');

  useEffect(() => {
    if (item) {
      setStatus(item.status);
      setNote(item.adminNote ?? '');
      setDup(item.duplicateOfId ? String(item.duplicateOfId) : '');
    }
  }, [item?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!item) {
    return (
      <Box sx={{ width: 340, flex: '0 0 auto', border: '1px dashed #BBBFC7', borderRadius: '12px', p: 2, color: '#7A7F88', fontSize: 14 }}>
        Обери звернення зі списку…
      </Box>
    );
  }

  const save = () => {
    dispatch(adminActions.patch({
      id: item.id,
      body: {
        status,
        adminNote: note,
        duplicateOfId: status === 'DUPLICATE' && dup ? Number(dup) : undefined,
      },
    }));
  };

  return (
    <Box sx={{ width: 340, flex: '0 0 auto', border: '1px solid #E7E7E7', borderRadius: '12px', p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Box sx={{ fontSize: 15, fontWeight: 700 }}>{item.title}</Box>
      <Box sx={{ fontSize: 12.5, color: '#7A7F88' }}>#{item.id} · {item.authorName}</Box>
      <Box sx={{ fontSize: 13, whiteSpace: 'pre-wrap' }}>{item.description}</Box>
      <TextField select size="small" label="Статус" value={status} onChange={(e) => setStatus(e.target.value as FeedbackStatus)}>
        {ALL_STATUSES.map((st) => <MenuItem key={st} value={st}>{STATUS_STYLE[st].label}</MenuItem>)}
      </TextField>
      {status === 'DUPLICATE' && (
        <TextField size="small" label="Дублікат до (ID)" value={dup} onChange={(e) => setDup(e.target.value)} />
      )}
      <TextField size="small" label="Внутрішня нотатка" value={note} onChange={(e) => setNote(e.target.value)} multiline minRows={3} inputProps={{ maxLength: 5000 }} />
      <UIButton variant="contained" disabled={saving} onClick={save}>{saving ? 'Збереження…' : 'Зберегти'}</UIButton>
    </Box>
  );
};

export default TriageDetail;
